// SCHIȚA DE VOLUMETRIE a omului, ca FANTOMĂ peste planul de situație
// (Cătălin, 8.10.2026): conturul volumelor din care a ieșit soluția, cu linie
// întreruptă, fără umplere, fără interacțiune. Atât — niciun procent, nicio
// listă: ecranul planului nu se încarcă.
//
// Volumele vin din `diagnostics.schita` al documentului, în coordonatele
// ABSOLUTE ale motorului (reperul lotului), deci trec prin aceeași traducere ca
// adnotările validatorului (`punctInCadru`), nu prin cea a obiectelor.

import { DECOR } from "./glyphs";

const SCHITA = "#5b3fb4";

export default function SchitaFantoma({ volume, la }: {
  volume: { id: string; poly: number[][] }[];
  /** traducerea unui punct absolut în cadrul desenului (v. `punctInCadru`) */
  la: (p: number[]) => number[];
}) {
  if (!volume.length) return null;
  return (
    <g style={DECOR} data-strat="schita">
      {volume.map((v) => (
        <polygon key={v.id}
                 points={v.poly.map((p) => la(p).join(",")).join(" ")}
                 fill="none" stroke={SCHITA} strokeWidth={1.6}
                 strokeDasharray="7 4" strokeLinejoin="round" opacity={0.85}
                 vectorEffect="non-scaling-stroke" />
      ))}
    </g>
  );
}
